import greetings from './pt/greetings'
import legacy from './pt/legacy'
import recordings from './pt/recordings'

import deck from './pt/deck.json'
import player from './pt/player.json'
import quickRecord from './pt/quick-record.json'
import recorder from './pt/recorder.json'
import share from './pt/share.json'
import videoPreview from './pt/video-preview.json'

const locale = {
  deck,
  player,
  quickRecord,
  recorder,
  share,
  videoPreview,
  translation: {
    ...greetings,
    ...legacy,
    ...recordings,
  },
}

export default locale
